<div class="tab-content">
  <div class="tab-header-row">
    <h2>Customer Contacts</h2>
    <button mat-button class="btn-bg-green" [disabled]="!canEdit" (click)="openContactForm()">+ Add Contact</button>
  </div>
  <rms-table [data]="Contacts" [columns]="Columns" [getIcons]="getIcons" ActionsText="Actions"></rms-table>
</div>
